import axiosCilentLoggig from "./axiosClientLogging";

export const exportLogging = async (data: any) => {
    try {
        const response = await axiosCilentLoggig.post(`/v1/logging`, data);
        console.dir(response)
        return
    }
    catch (error) {
        console.dir(error)
        return Promise.reject({ success: false, error });
    }
}

/**
 * infoログ出力
 * 
 * @param msg 
 * @param tenant_id 
 */
export async function outInfoLog(msg: unknown, tenant_id: string | undefined) {
    const outMsg = typeof msg === "string" ? msg : String(msg);
    const data = { "log_level": "info",
                   "app_name" : "webapp",
                   "is_audit" : false,
                   "tenant_id": tenant_id ?? "",
                   "message"  : outMsg
                 };

    await exportLogging(data);
}